import axios from 'axios';
import utils from '../utils/utils'
import router from '../router'

// let baseURL = null;
// if (process.env.NODE_ENV == 'development') {
//     // baseURL = 'http://192.168.50.100:8999';
//     baseURL = 'https://sandbox-venue-api.peiso.com.au';
//     // baseURL =  'https://venue-api.peiso.com.au'
// }
// else if (process.env.NODE_ENV == 'production') {
//     baseURL =  'https://venue-api.peiso.com.au'
// }

const baseURL = process.env.ENDPOINT_BASE_URL            // to reconfigure go to config.env.js and change the ENDPOINT_BASE_URL value


// 创建axios实例
let service = axios.create({
    timeout: 600000, // 请求超时时间
    responseType: 'json',
    headers: {
        "Content-Type": "application/json",
        'Accept-Language': 'en-US'
    }
})

// 请求拦截
service.interceptors.request.use(
    config => {
        const token = window.sessionStorage.getItem("token");
        token && (config.headers.token = token);

        const subVenueId = window.sessionStorage.getItem("subVenueId");
        subVenueId && (config.headers['subVenueId'] = subVenueId);

        return config;
    },
    error => {
        return Promise.error(error);
})

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

const requestMethod = ['get', 'delete', 'post', 'put']

const $axios = {}

requestMethod.forEach(method => {
    $axios[method] = function(url, data = {}, cancelToken) {
        return new Promise((resolve, reject) => {
            if (method === 'get') {
      
                service[method](`${baseURL}${url}`, {cache: false, cancelToken: cancelToken})
                .then(response => {
                    packageRespon(response, resolve);
                }, err => {
                    reject(err)
                    // packageError(err)
                })
                .catch((error) => {
                    reject(error)
                    packageCatch(error)
                })
            } else if (method === 'delete') {
                service[method](baseURL + url, {data}, {cancelToken: cancelToken})
                .then(response => {
                    packageRespon(response, resolve);
                }, err => {
                    reject(err)
                    // packageError(err, url)
                })
                .catch((error) => {
                    reject(error)
                    packageCatch(error)
                })
            } else {
                service[method](baseURL + url, data, {cancelToken: cancelToken})
                .then(response => {
                    packageRespon(response, resolve);
                }, err => {
                    reject(err)
                    // packageError(err, url)
                })
                .catch((error) => {
                    reject(error)
                    packageCatch(error)
                })
            }
        })
    }
})

function packageRespon(res, resolve) {
    if (res.status == 200) {
        if(res.data){
            if(res.data!=null&&res.data.code==401){
                router.push({path: '/login'})
                utils.alert2('', 'Expiration of authentication' ,'error');
                return
            } else if(res.data.code == 8902||res.data.code == 8901||res.data.code == 90000||res.data.code == 90002){
                router.push({path: '/login'})
                localStorage.clear()
                utils.alert2('', res.data.message ,'error');
                return
            }
        }

        resolve(res);
    } else {
        // utils.alert2('', res.data.message ,'error');
    }
}



function packageError(err, url) {
    if (err !== 'Operationcanceled' && err.message !== 'Operationcanceled') {
        if (err == 'Error: timeout of 60000ms exceeded') {
            utils.alert2('', 'Unable to connect to the server.' ,'error');
        } else if (err == 'Error: Network Error' || err.message == 'Network Error'){
            utils.alert2('', 'Unable to connect to the server.', 'error')
        } else {
            // utils.alert2('', err ,'error');
        }
    } else {
      // Temporary fix for Operationcanceled alert message
        // utils.alert2('', err, 'error')
    }
}


function packageCatch(err) {
    utils.alert2('', err ,'error');
}


export default $axios



// WEBPACK FOOTER //
// ./src/api/http.js